import { Convention } from '../../../concepts/objects';
import { ToolSettings } from '../tooling/ToolBehavior';
import { Physical } from './Physical';

export interface RepeatInfo {
    toolId: string;
    toolSettings?: ToolSettings;
}

export interface Repeatable extends Physical {
    queryRepeat(): RepeatInfo | null;
}

export const Repeatable = new Convention<Repeatable>('Repeatable');
